import React, { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import classes from "./DarsJadvali.module.css";

// Worker `public/` papkasidan beriladi (node_modules/pdfjs-dist/build/pdf.worker.min.js nusxasi).
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

/**
 * PDF'ni sahifaning o'zida chizadi (pdf.js). iframe/embed ishlatilmaydi:
 * serverdagi media X-Frame-Options: DENY bilan keladi va brauzer uni frame ichida bloklaydi.
 */
const PdfViewer = ({ url, loadingText, errorText }) => {
  const containerRef = useRef(null);
  const [state, setState] = useState({ status: "loading", pages: 0 });

  useEffect(() => {
    let cancelled = false;
    let loadingTask = null;
    const container = containerRef.current;
    if (!container || !url) return undefined;

    container.innerHTML = "";
    setState({ status: "loading", pages: 0 });

    const render = async () => {
      try {
        loadingTask = pdfjsLib.getDocument({ url, withCredentials: false });
        const pdf = await loadingTask.promise;
        if (cancelled) return;

        // Sahifa kengligi konteynerga moslanadi; devicePixelRatio bilan matn keskin chiqadi.
        const availableWidth = Math.max(container.clientWidth - 2, 320);
        const dpr = window.devicePixelRatio || 1;

        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
          if (cancelled) return;
          const page = await pdf.getPage(pageNumber);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = availableWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement("canvas");
          canvas.className = classes.pdfPage;
          canvas.width = Math.floor(viewport.width * dpr);
          canvas.height = Math.floor(viewport.height * dpr);
          canvas.style.width = `${Math.floor(viewport.width)}px`;
          canvas.style.height = `${Math.floor(viewport.height)}px`;
          container.appendChild(canvas);

          const ctx = canvas.getContext("2d");
          await page.render({
            canvasContext: ctx,
            viewport,
            transform: dpr !== 1 ? [dpr, 0, 0, dpr, 0, 0] : undefined,
          }).promise;
        }

        if (!cancelled) setState({ status: "ready", pages: pdf.numPages });
      } catch (err) {
        if (!cancelled) {
          console.error("PDF render error:", err);
          setState({ status: "error", pages: 0 });
        }
      }
    };

    render();

    return () => {
      cancelled = true;
      if (loadingTask) loadingTask.destroy();
    };
  }, [url]);

  return (
    <div className={classes.pdfWrap}>
      {state.status === "loading" && <div className={classes.state}>{loadingText}</div>}
      {state.status === "error" && (
        <div className={`${classes.state} ${classes.error}`}>{errorText}</div>
      )}
      <div ref={containerRef} className={classes.pdfPages} />
    </div>
  );
};

export default PdfViewer;
